import React, {lazy} from 'react';
import {fromJS} from 'immutable';

import {requireSession} from 'lib/decorators/requireSession';
import sessionStore from 'client/Session/SessionStore';
import Subheader from 'generic/Subheader/Subheader.react';
import {createRoute, layoutComponent, withRouter} from 'client/routeHelpers';

const BatchSchoolLicenses = lazy(() => import('./BatchSchoolLicenses.react'));
const BatchSchools = lazy(() => import('./BatchSchools.react'));
const BatchUsers = lazy(() => import('./BatchUsers.react'));
const BatchConfirmUsers = lazy(() => import('./Users/BatchConfirmUsers.react'));
const BatchCOPPAConsent = lazy(() => import('./Users/BatchCOPPAConsent.react'));
const BatchClassrooms = lazy(() => import('./Classrooms/BatchClassrooms.react'));
const BatchClassroomSubjects = lazy(() => import('./Classrooms/BatchClassroomSubjects.react'));
const BatchEnrollStudents = lazy(() => import('./BatchEnrollStudents.react'));

const BATCH_LINKS = fromJS([
  {
    name: 'Schools',
    route: '/dennis/batch/schools'
  },
  {
    name: 'School Licenses',
    route: '/dennis/batch/school-licenses'
  },
  {
    name: 'Users',
    route: '/dennis/batch/users'
  },
  {
    name: 'Users : Confirm',
    route: '/dennis/batch/users/confirm'
  },
  {
    name: 'Users : COPPA',
    route: '/dennis/batch/users/coppa'
  },
  {
    name: 'Classrooms',
    route: '/dennis/batch/classrooms'
  },
  {
    name: 'Classroom : Subjects',
    route: '/dennis/batch/classroom/subjects'
  },
  {
    name: 'Enroll Students',
    route: '/dennis/batch/enroll-students'
  }
]);

const Batch = requireSession({
  rolePredicate: () => sessionStore.isSuper()
})((props) => (
  <div>
    <Subheader links={BATCH_LINKS} activePath={props.location.pathname} exactMatch />
    {props.children}
  </div>
));

export function makeBatchRoute(parentRoute) {
  const batchRoute = createRoute({
    getParentRoute: () => parentRoute,
    path: 'batch',
    component: layoutComponent(Batch)
  });
  return batchRoute.addChildren([
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'school-licenses',
      component: withRouter(BatchSchoolLicenses)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'schools',
      component: withRouter(BatchSchools)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'users',
      component: withRouter(BatchUsers)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'users/confirm',
      component: withRouter(BatchConfirmUsers)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'users/coppa',
      component: withRouter(BatchCOPPAConsent)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'classrooms',
      component: withRouter(BatchClassrooms)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'classroom/subjects',
      component: withRouter(BatchClassroomSubjects)
    }),
    createRoute({
      getParentRoute: () => batchRoute,
      path: 'enroll-students',
      component: withRouter(BatchEnrollStudents)
    })
  ]);
}
